<template>
  <Form :method="method" :action="action" :form-data="form" @success="success">
    <template v-slot="{ errors, submitting }">
      <div class="sm:flex items-center mb-2">
        <label for="firstname" class="block w-32 py-2 flex-shrink-0">Naam</label>
        <div class="w-full flex">
          <BaseInput
            name="firstname"
            id="firstname"
            v-model="form.firstname"
            :error="errors.firstname"
            placeholder="Voornaam"
            class="w-1/2 mr-2"
            required
            v-focus
          />
          <BaseInput
            name="lastname"
            v-model="form.lastname"
            :error="errors.lastname"
            placeholder="Achternaam"
            class="w-1/2"
            required
          />
        </div>
      </div>
      <label v-for="field in fields" :key="field.identifier" class="sm:flex block w-full mb-2">
        <span class="block w-32 py-2 flex-shrink-0">{{ field.name }}</span>
        <div class="w-full">
          <BaseInput
            :name="field.identifier"
            v-model="form[field.identifier]"
            :error="errors[field.identifier]"
            :required="field.required"
            :type="field.type"
            :class="field.class"
          />
        </div>
      </label>
      <div v-if="isNew" class="sm:flex block w-full my-3">
        <span class="block w-32 py-2 flex-shrink-0"></span>
        <div>
          <BaseCheckbox
            name="create_contact"
            v-model="form.create_contact"
          >Maak dossier aan voor deze persoon</BaseCheckbox>
          <div
            class="text-gray-400 text-sm ml-6"
          >Personen met een dossier kunnen deals, notities en reminders krijgen.</div>
        </div>
      </div>

      <div v-if="isNew" class="my-8">
        <div
          class="my-2 font-semibold"
        >Bij welke organisatie is {{ form.firstname || 'deze persoon' }} werkzaam?</div>
        <label class="sm:flex block w-full">
          <span class="hidden sm:block w-32 py-2 flex-shrink-0">Organisatie</span>
          <OrganizationPicker
            v-model="form.organization_id"
            :error="errors.organization_id"
            class="w-full"
          />
        </label>
      </div>
      <div class="flex items-center my-8">
        <div class="sm:ml-32">
          <button type="submit" class="btn btn-blue" :disabled="submitting">Opslaan</button>
          <button type="button" class="cancel" @click="$router.back()">Annuleren</button>
        </div>
      </div>
    </template>
  </Form>
</template>

<script>
import Form from "@/components/Form";
import OrganizationPicker from "@/components/OrganizationPicker";

export default {
  props: {
    action: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: "post"
    },
    person: {
      type: Object
    },
    isNew: {
      type: Boolean
    }
  },

  components: {
    Form,
    OrganizationPicker
  },

  data() {
    return {
      form: {
        firstname: "",
        lastname: "",
        create_contact: false,
        organization_id: null
      }
    };
  },

  created() {
    this.fillForm();
  },

  computed: {
    fields() {
      return this.$store.getters.personFields
        .filter(field => field.identifier !== "fullname")
        .map(field => {
          return {
            ...field,
            type: field.identifier == "email" ? "email" : "text",
            class: field.identifier == "telephone" ? "w-40" : ""
          };
        });
    }
  },

  methods: {
    success(data) {
      this.$emit("success", data);
    },

    fillForm() {
      let person = this.person || {};

      this.form.firstname = person.firstname;
      this.form.lastname = person.lastname;

      for (let field of this.fields) {
        this.$set(this.form, field.identifier, person[field.identifier]);
      }
    }
  }
};
</script>
